module.exports = __webpack_public_path__ + "static/gallery_06-10df9dc5cdc7fe2ff8fb18928d1e2f31.jpg";